<ng-container *ngFor="let question of questions; let questionIndex = index">
  <ng-container *ngIf="utilService.shouldShowQuestion(question)">
    <div
      class="list-item-container"
      [formGroup]="formGroup"
      [id]="
        UtilService.HtmlElementIdUq(
          sectionIndex,
          questionIndex,
          sectionId,
          question.questionId
        )
      "
      [ngClass]="{
        error: shouldShowError(question) && isError(question, questionIndex)
      }"
    >
      <app-question-list-header
        [questionTitle]="
          UtilService.findObj(
            question.questionTranslations,
            'questionTranslationLanguageId',
            sharedDataService.getLanguageIdForForm()
          ).questionTranslationTitle
        "
        [note]="
          question.allowInstructionOrNote
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationInstructionOrNote
            : ''
        "
        [required]="question.questionIsRequired"
        [attachments]="question.questionAttachments"
        [attachmentIcon]="
          sharedDataService.offlineMode
            ? utilService.getOfflineFileUrl(
                question.questionAttachmentIconPath,
                'icon'
              )
            : question.questionAttachmentIconPath
        "
        [qNo]="
          (questionElementIds
            ? questionElementIds.indexOf(
                UtilService.HtmlElementIdUq(
                  sectionIndex,
                  questionIndex,
                  sectionId,
                  question.questionId
                )
              )
            : questionIndex) + 1
        "
      ></app-question-list-header>

      <div class="hr-line"></div>

      <app-single-choice-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.SingleChoiceSet
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getNonNullQuestionAnswerByQuestionID(question.questionId,question.parentQuestionID, 'singleChoiceValueID')
                ?.singleChoiceValueID
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [list]="question.answerChoiceAttributes"
        [isShowAnswerScoreEnabled]="isShowAnswerScoreEnabled"
        (answerUpdated)="onAnswerUpdated($event)"
        [questionId]="question.questionId"
      ></app-single-choice-field>

      <app-multiple-choice-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.MultipleChoiceSet
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getNonNullQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID , 'multipleChoiceValueIDs')
                ?.multipleChoiceValueIDs
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [questionId]="question.questionId"
        [list]="question.answerChoiceAttributes"
        [isShowAnswerScoreEnabled]="isShowAnswerScoreEnabled"
        (answerUpdated)="onAnswerUpdated($event)"
      ></app-multiple-choice-field>

      <app-confirm-box-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.ConfirmationBox
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)
                ?.isConfirmBoxChecked
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [questionId]="question.questionId"
        [list]="question.questionTranslations"
        (answerUpdated)="onAnswerUpdated($event)"
      ></app-confirm-box-field>

      <app-qr-code-scan-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.ScanQrCodeField
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)
            : false
        "
        [formControlName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        [allowedQrCodeTypes]="getAllowedQrCodeTypes(question)"
      ></app-qr-code-scan-field>

      <app-matrix-three-d-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.Matrix3DField
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.matrixQAnswer
            : false
        "
        [formControlName]="UtilService.FCUniqueName(section, question)"
        [question]="question"
        [isError]="isError(question, questionIndex)"
        [allowedQrCodeTypes]="getAllowedQrCodeTypes(question)"
      ></app-matrix-three-d-field>

      <app-singleline-text-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.SingleLineText
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.textValue
            : false
        "
        [form]="formGroup"
        [isError]="isError(question, questionIndex)"
        [inputName]="UtilService.FCUniqueName(section, question)"
      ></app-singleline-text-field>

      <app-multiline-text-field
        [isError]="isError(question, questionIndex)"
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.MultiLineText
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.textValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
      ></app-multiline-text-field>

      <app-number-integer-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.NumberFieldInteger
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.integerValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
      ></app-number-integer-field>

      <app-number-decimal-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.NumberFieldDecimal
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.decimalValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
      ></app-number-decimal-field>

      <app-date-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.DateField
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.dateValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        placeholder="Choose"
        [uniqueId]="question.questionId"
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
      ></app-date-field>

      <app-time-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.TimeField
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.timeValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
        [uniqueId]="question.questionId"
      ></app-time-field>

      <app-date-time-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.DateTimeField
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.dateTimeValue
            : false
        "
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [isError]="isError(question, questionIndex)"
        placeholder="Choose"
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
        [uniqueId]="question.questionId"
      ></app-date-time-field>

      <app-photo-field
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.PhotoVideoUpload
        "
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getUniqueImageVideoDocFileDetails(question.questionId, question.parentQuestionID)
            : false
        "
        [formControlName]="UtilService.FCUniqueName(section, question)"
        [defaultValue]="
          sharedDataService.savedFormStateData
            ? sharedDataService.savedFormStateData[
                UtilService.FCUniqueName(section, question)
              ]
            : null
        "
        [label]="
          question.allowTextLabel
            ? UtilService.findObj(
                question.questionTranslations,
                'questionTranslationLanguageId',
                sharedDataService.getLanguageIdForForm()
              ).questionTranslationTextLabel
            : ''
        "
      ></app-photo-field>

      <app-inform-signature-container
        *ngIf="
          question.selectedAnswerTypeId ===
          EnumService.CustomAnswerType.InformSignature
        "
        [question]="question"
        [userList]="userList"
        [form]="formGroup"
        [inputName]="UtilService.FCUniqueName(section, question)"
        [formControlName]="UtilService.FCUniqueName(section, question)"
        [preValue]="
          getQuestionPermissionAnswerByQuestionID(question.questionId)
            ?.isQuestionRelaunchable
            ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)?.signatureAnswer?.signatureAnswers
            : null
        "
      ></app-inform-signature-container>

      <app-body-map-custom-question
  *ngIf="question.selectedAnswerTypeId === 18"
  [form]="formGroup"
  [questionIsRequired]="question.questionIsRequired"
  [inputName]="UtilService.FCUniqueName(section, question)"
  [preValue]="
    getQuestionPermissionAnswerByQuestionID(question.questionId)
      ?.isQuestionRelaunchable
      ? getQuestionAnswerByQuestionID(question.questionId, question.parentQuestionID)
          ?.bodyPartIDs
      : false
  "
></app-body-map-custom-question>
      
      <!-- <app-activity-popup
        *ngIf="showActivityPopup"
      ></app-activity-popup> -->

      <ng-container *ngIf="question.shouldShowOptionalComment">
        <div class="hr-line"></div>
        <app-multiline-text-field
          label="Additional Comment"
          [form]="formGroup"
          [inputName]="
            UtilService.FCNameAdditioanlNoteUq(
              UtilService.FCUniqueName(section, question)
            )
          "
        ></app-multiline-text-field>
      </ng-container>

      <ng-container *ngIf="question.shouldShowOptionalAction">
        <div class="hr-line"></div>
        <app-multiline-text-field
          label="Action"
          [form]="formGroup"
          [inputName]="
            UtilService.FCNameActionUq(
              UtilService.FCUniqueName(section, question)
            )
          "
        ></app-multiline-text-field>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
